module.exports = __webpack_public_path__ + "static/img/1-1Z603162Z4C0.49d1ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z603162Z4C0.jpg
// module id = b8g3
// module chunks = 0